import React from "react";
import { sponsors } from "../../assets/sponsored_content/sponsors.js";
import { ExpandableText } from "components/ExpandableText";


const SponsorsSection = () => {
  return (
    <section className="relative py-20 bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 text-warmGray-700" id="sponsor-section">
      <div className="container mx-auto px-4 text-left">
        <div className="inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-lsfm-primary-500">
          <i className="fas fa-handshake text-white text-2xl"></i>
        </div>

        <h2 className="text-3xl font-semibold mb-4">Mūsu sponsori un bonusa materiāli</h2>
        <p className="text-lg text-slate-300 max-w-2xl mx-auto mb-12">
          Paldies mūsu atbalstītājiem par ieguldījumu LSFM konferences norisē.
          Kopā mēs veicinām kaķu veselības aprūpes attīstību Latvijā.
        </p>

        {/* Tiers */}
        <div className="space-y-16">
          {/* Platinum */}
          <SponsorTier title="Starptautiskais Partneris" tierColor="bg-red-500" icon={"fa-crown"} highlight>
            {sponsors.platinum}
          </SponsorTier>

          {/* Gold */}
          <GoldSponsorTier title="Gold Partneris" tierColor="bg-amber-300" icon={"fa-heart"}>
            {sponsors.gold}
          </GoldSponsorTier>

          {/* Silver */}
          <SponsorTier title="Silver Partneris" tierColor="bg-gray-300">

            {sponsors.silver}
          </SponsorTier>

          {/* Bronze */}
          <SponsorTier title="Bronze Partneri" tierColor="bg-orange-400">
            {sponsors.bronze}
          </SponsorTier>

          {/* Promo */}
          <SponsorTier title="Info Partneris" tierColor="bg-teal-300" icon={'fa-bullhorn'}>
            {sponsors.promo}
          </SponsorTier>
        </div>
      </div>
    </section>
  );
};

const SponsorTier = ({ title, children, highlight }) => {
  return (
    children && children.length > 0 && <div className={`text-center  flex flex-col items-center m-4 mt-8`}>
      <h3
        className={`text-2xl font-semibold mb-4 tracking-wide `}
      >
        {title}
      </h3>

      <div
        className={`flex flex-wrap justify-center items-center gap-4 ${highlight ? "scale-105" : ""
          } `}
      >
        {children.map((sponsor, index) => (
          <a
            key={index}
            href={sponsor.link}
            target="_blank"
            rel="noopener noreferrer"
            className={`group p-4 relative flex flex-col items-center 
                justify-center transition-all   w-48 h-32
                hover:opacity-80`}
          >
            <img
              src={sponsor.logo}
              alt={sponsor.name}
              className="max-h-20 max-w-340-px object-contain  transition-transform duration-300 "
              style={{ maxHeight: "180px" }}
            />
            <div className="hover:text-blueGray-500 text-blueGray-700 bottom-2 text-md text-slate-800 opacity-70 group-hover:opacity-100">
              {sponsor.name}
            </div>
            {sponsor.sponsoredContent && <button
              onClick={() => {
                window.open(sponsor.sponsoredContent, '_blank');
              }}
              className=" m-4  text-warmGray-800 bg-lsfm-secondary-100  text-sm px-3 py-3  shadow hover:shadow-lg transition-all duration-150 ease-in-out"
            >
              Lejupielādēt sponsora materiālu
            </button>}
          </a>
        )
        )}
      </div>
    </div>
  );
};

const GoldSponsorTier = ({ title, children, highlight }) => {
  return (
    children && children.length > 0 && <div className={`text-center  flex flex-col items-center m-4 mt-8`}>
      <h3
        className={`text-2xl font-semibold mb-4 tracking-wide `}
      >
        {/* <i className={`fas ${icon} text-warmGray-700 mr-2`}></i> */}{title}
      </h3>

      <div
        className={`flex flex-wrap justify-center items-center gap-4 ${highlight ? "scale-105" : ""
          } `}
      >


        {children.map((sponsor, index) => (<div className="w-full lg:w-10/12  px-4 mr-auto ml-auto">
          <div className="relative flex flex-col  min-w-0 break-words p-4  bg-white w-full mb-6 shadow-lg rounded-lg border-2 border-lsfm-primary-500">
            <div className="relative flex flex-col justify-center  ">



              <img
                src={sponsor.logo}
                alt={sponsor.name}
                className="h-480-px max-w-200-px  mx-auto  object-contain rounded-lg"
                style={{ objectFit: "cover" }}
              />

            </div>
            <div className="flex flex-col  justify-center p-8 ">
              <h4 className="text-xl font-bold text-warmGray-800 text-left pb-2">
                {sponsor.name}
              </h4>



              <ExpandableText
                textClass={"text-warmGray-800 text-left"}
                text={`${sponsor.description}`}
                maxLength={400}
                clampClass={"line-clamp-7"}
              />

              {sponsor.files && (
                <div className="flex flex-col w-full mt-6">
                  {/* Header */}
                  <hr />
                  <div className="flex  items-center mb-3 mt-3 mr-4">
                    <i className="fas fa-shopping-bag text-3xl text-warmGray-700 mr-3"></i>
                    <p className="text-lg font-medium text-warmGray-800">Partnera materiāli</p>
                  </div>

                  {/* Files in a horizontal scrollable row */}
                  <div className="flex flex-wrap gap-4 overflow-x-auto py-2">
                    {sponsor.videoURL && (
                      <div className=" h-28 px-4 py-2 bg-white rounded-xl shadow flex items-center justify-center">
                        <iframe
                          width="100%"
                          src={sponsor.videoURL}
                          title="Sponsor Video"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                          className="rounded-lg"
                        ></iframe>
                      </div>
                    )
                    }
                    {sponsor.files.map((file, fileIndex) => (
                      <a
                        key={fileIndex}
                        href={file.file}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex flex-col items-center justify-between
                     min-w-[150px] h-28 px-4 py-2 border-2 bg-white  shadow
                     hover:shadow-md transition-all rounded-lg"
                      >
                        <i className="fas fa-file-download text-4xl  text-lsfm-primary-600 mb-2"></i>
                        <span className="text-sm max-w-150-px  text-black opacity-80 group-hover:opacity-100 text-center">
                          {file.name}
                        </span>

                        Lejupielādēt
                      </a>
                    ))}
                  </div>
                </div>
              )}


            </div>
          </div>

        </div>))}
      </div>
    </div>
  )
}

export default SponsorsSection;